import React from 'react';
import PropTypes from 'prop-types';

import { useCookies } from 'react-cookie';
import { Navigate, useLocation } from 'react-router-dom';

function CheckAuth({ children }) {
    const [cookies] = useCookies(['access']);
    let location = useLocation();

    if (!cookies.access) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return children;
}

CheckAuth.propTypes = {
    children: PropTypes.node
};

export default CheckAuth;
